// Fragment "HQ AI, S8 round 3" — merged into ./index.js.
// Convention: flat dotted keys, values in the 3 languages, never empty.
// Backs super_admin/HqAi.jsx under data.insights.write and own-only sessions
// (hq-customers-contract.md 3.2). The older hqai.* keys stay in base.js.
export default {
  fr: {
    "hqai.sessionUnavailable": "Cette conversation n'est pas disponible.",
    "hqai.noInsightsReadOnly": "Aucun briefing pour l'instant.",
    "hqai.agentReadOnly": "Votre rôle permet de relire vos conversations, pas d'en écrire.",
  },
  en: {
    "hqai.sessionUnavailable": "This conversation is not available.",
    "hqai.noInsightsReadOnly": "No briefing yet.",
    "hqai.agentReadOnly": "Your role lets you read your conversations, not write in them.",
  },
  es: {
    "hqai.sessionUnavailable": "Esta conversación no está disponible.",
    "hqai.noInsightsReadOnly": "Todavía no hay ningún briefing.",
    "hqai.agentReadOnly": "Tu rol te permite leer tus conversaciones, no escribir en ellas.",
  },
};
